import { ApiService } from './apiService'
import { baseApiUrl } from '../config'
import { Adtech, CompanyIntegrationDto, PriceDto } from '../types/Pricing'

export class PricingService extends ApiService {
    constructor(baseUrl: string) {
        super(baseUrl)
    }

    async getCompanyIntegration(adtech: Adtech, id: number): Promise<CompanyIntegrationDto | null> {
        return this.get(`/api/admin/v3/${adtech}/company/${id}`)
    }

    async getAdtechPrices(): Promise<PriceDto[]> {
        return this.get(`/api/admin/v3/price`)
    }

    async getCompaniesByIntegration(adtech: Adtech, id: string): Promise<string[]> {
        return this.get(`/api/admin/v3/${adtech}/seat/${id}`)
    }

    async updateCompanyIntegration(adtech: Adtech, id: number, data: CompanyIntegrationDto): Promise<CompanyIntegrationDto> {
        return this.put(`/api/admin/v3/${adtech}/company/${id}`, data)
    }

    async createCompanyIntegration(adtech: Adtech, id: number, data: CompanyIntegrationDto): Promise<CompanyIntegrationDto> {
        return this.post(`/api/admin/v3/${adtech}/company/${id}`, data)
    }

    async deleteCompanyIntegration(adtech: Adtech, id: number): Promise<null | { message: string }> {
        return this.del(`/api/admin/v3/${adtech}/company/${id}`)
    }
}

export const pricingService = new PricingService(baseApiUrl)
